import React from 'react'
import ProductTabs from '../components/productsection/ProductTabs'

export default function ProductPage() {
  return (
    <div>
      <ProductTabs />
    </div>
  )
}
